// extracted by mini-css-extract-plugin
export default {"price":"q9-z","priceRow":"r9-z","onSale":"s9-z","msrpLabelPrice":"t9-z","msrpLabel":"u9-z","originalPrice":"v9-z","percentOff":"w9-z"};